<template>
  <!-- -->
  <list-page :show-border="false" :show-shadow="false">
    <table-list :show-shadow="false" :show-border="false">
      <separate-page :show-shadow="false" :show-border="true">
        <template #category>
          <el-tree ref="groupTree" node-key="id" :data="treeList" :current-node-key="currentData.id"
                   :props="{ children: 'children', label: 'dictName' }" @node-click="selectData" default-expand-all
                   :expand-on-click-node="false">
            <template v-slot="{ node, data }">
              <span :class="currentData.id === data.id? 'custom-tree-node on': 'custom-tree-node'">
                <span class="node-name">
                  <span class="form-tag" v-if="data.formType">
                    <span v-for="(o, i) in serviceList" :key="i"><span v-if="data.formType === o.formType">{{o.formName? o.formName.slice(0,1): '无'}}</span></span>
                  </span>
                  <span>{{ node.label }}</span>
                </span>
                <span class="node-option">
                  <el-dropdown @command="moreOption($event, data)">
                    <template #default>
                    <yq-icon name="more-2"/>
                  </template>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item command="addNewCategory">
                        <yq-icon name="element-ui_plus"/>
                        {{ $t("message.toAddNew") }}{{$t("message.nextLevel")}} <!-- 新建 -->
                      </el-dropdown-item>
                      <el-dropdown-item command="editCategory" v-if="data.id">
                        <yq-icon name="element-ui_edit"/>
                        <!--              编辑-->{{$t("message.toEdit")}}{{$t("message.data")}}
                      </el-dropdown-item>
                      <el-dropdown-item command="deleteCategory"  v-if="data.id">
                        <yq-icon name="element-ui_delete"/>
                        <!--              删除-->{{$t("message.toDelete")}}{{$t("message.data")}}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                  </el-dropdown>
                </span>
              </span>
            </template>
          </el-tree>
        </template>
        <template #default>
          <list-page :show-shadow="false" :show-border="false">
            <form-page :show-page="false" :show-shadow="false" :show-border="false">
              <template #left>自定义配置</template>
              <page-button type="write" el-type="success" :disabled="currentData.id === '-1'" @click="editColumn(null, -1)">添加字段</page-button>
            </form-page>
            <table-list class="dynamic-content" :show-shadow="false" :show-border="false">
              <yq-table :data="currentData.dynamicInfoJson" border stripe id="dragTable" ref="yqTable">
                <yq-table-column label="字段名称" prop="labelName" width="120rem"/>
                <yq-table-column label="字段编码" prop="userCode" width="120rem"/>
                <yq-table-column label="字段类型" prop="labelType" width="120rem">
                  <template v-slot="{row}">
                    <span v-for="(o, i) in columnTypes" :key="i"><span v-if="row.labelType === o.value">{{o.name}}</span></span>
                  </template>
                </yq-table-column>
                <yq-table-column label="占位" prop="columnCount" width="60rem" />
                <yq-table-column label="选项/参数" prop="labelLimit" show-overflow-tooltip>
                  <template v-slot="{row}">
                    <span v-if="row.labelType === 11 || row.labelType === 12">文本长度: {{row.labelLength}}</span>
                    <span v-else-if="row.labelType === 22">小数位数</span>
                    <span v-else-if="row.labelType === 41">图片数量: {{row.imageLength}}</span>
                    <span v-else-if="row.labelType === 51">
                      <el-tag class="el-tag-option" v-for="(op, i) in row.labelOptions" :key="i">{{op}}</el-tag>
                    </span>
                    <span v-else-if="row.labelType === 52">
                      <el-tag class="el-tag-option" v-for="(op, i) in row.labelOptions" :key="i">{{op}}</el-tag>
                    </span>
                  </template>
                </yq-table-column>
                <yq-table-column label="操作" prop="options" fixed="right" align="center" width="120rem">
                  <template v-slot="{ row, $index }">
                    <table-button type="write" @click="editColumn(row, $index)">编辑</table-button>
                    <table-button type="delete" el-type="danger" message="是否确认删除字段，删除后不可恢复" @click="deleteColumn($index)">删除</table-button>
                  </template>
                </yq-table-column>
              </yq-table>
            </table-list>
          </list-page>
        </template>
      </separate-page>
    </table-list>
    <el-dialog v-model="showColumnSetting" title="编辑自定义字段" dialog-width="1" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="字段名称" required>
          <el-input v-model="currentColumn.labelName" />
        </el-form-item>
        <el-form-item label="字段编码" required>
          <el-input v-model="currentColumn.userCode" />
          <span class="form-item-desc">字段编码不能重复，否则可能导致显示异常</span>
        </el-form-item>
        <el-form-item label="占位">
          <el-input v-model="currentColumn.columnCount" />
        </el-form-item>
        <el-form-item label="字段类型">
          <el-select v-model="currentColumn.labelType" >
            <el-option v-for="(n, i) in columnTypes" :label="n.name" :value="n.value" :key="i"/>
          </el-select>
        </el-form-item>
        <el-form-item label="文本长度" v-if="currentColumn.labelType === 11 || currentColumn.labelType === 12">
          <el-input v-model="currentColumn.labelLength" />
        </el-form-item>
        <el-form-item label="小数位数" v-if="currentColumn.labelType === 22">
          <el-input v-model="currentColumn.scale" />
        </el-form-item>
        <el-form-item label="图片数量" v-if="currentColumn.labelType === 41">
          <el-input v-model="currentColumn.imageLength" />
        </el-form-item>
        <el-form-item label="选项内容" v-if="currentColumn.labelType === 51 || currentColumn.labelType === 52">
          <div class="label-options" v-for="(op, i) in currentColumn.labelOptions" :key="i">
            <div class="option">
              <el-input v-model="currentColumn.labelOptions[i]"/>
              <yq-icon name="element-ui_close" class="yq-icon" @click.stop="removeOption(i)"/>
            </div>
          </div>
          <div class="label-options">
            <el-input v-model="currentOption" v-if="showCurrentOption" placeholder="请添加选项值" @blur="addOption2Label"/>
          </div>
          <div class="label-options level-1" @click="addLabelOption"><yq-icon name="element-ui_plus"/></div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <page-button @click="showColumnSetting = !showColumnSetting">取消</page-button>
        <page-button type="write" el-type="primary" @click="addColumn2List">保存</page-button>
      </div>
    </el-dialog>
    <el-dialog dialog-width="1" title="编辑字典信息" :close-on-click-modal="false" v-model="showDictionary">
      <el-form>
        <el-form-item label="上级分类">
          <dictionary v-model="currentData.parentId" :dictionaries="dictionaryList" dict-code="id" dict-name="dictName" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="字典名称">
          <el-input v-model="currentData.dictName"/>
        </el-form-item>
        <el-form-item label="字典编码">
          <el-input v-model="currentData.userCode"/>
        </el-form-item>
        <el-form-item label="字典排序">
          <el-input v-model="currentData.index"/>
        </el-form-item>
        <el-form-item label="适用范围">
          <el-select v-model="currentData.formType" clearable>
            <el-option v-for="(n, i) in serviceList" :label="n.formName" :value="n.formType" :key="i"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <page-button @click="showDictionary = !showDictionary">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveData">保存</page-button>
      </div>
    </el-dialog>
  </list-page>
</template>

<script>
import SeparatePage from "@/components/h5/layout/SeparatorPage.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import TableList from "@/components/h5/layout/ListTable.vue";
import dictionaryApi from "@/api/normal/sys/dictionaryApi";
import FormPage from "@/components/h5/layout/FormPage.vue";
import util from "@/util/util";
import TableButton from "@/components/h5/button/TableButton.vue";
import Dictionary from "@/components/h5/data/Dictionary.vue";
import Sortable from "sortablejs";
import PageButton from "@/components/h5/button/PageButton.vue";
import YqIcon from "@/components/YqIcon.vue";
import {ElMessageBox} from "element-plus";
export default {
  props: {
    dictionSetting: {
      default: () => {
        return {
          dictCode: "",
          dictName: "",
          imageType: 0,
          imageBackground: "",
          imageInfront: "",
          // 0:不可编辑，1:可编辑
          editAble: 0,
        }
      }
    }
  },
  name: "",
  components: {
    YqIcon,
    PageButton,
    TableButton,
    FormPage,
    SeparatePage, ListPage, SearchCondition, TableList, Dictionary
  },
  data() {
    return {
      searchInfo: {
        searchKey: "",
        category: "",
      },
      treeList: [], // 左边的树
      dictionaryList: [], // 字典数据
      currentData: {
        id: "-1",
        formType: "",
      },
      serviceList: [], // 有哪些服务
      showColumnSetting: false, // 是否显示字段设置
      currentColumn: {},
      currentOption: "", // 选项值，向字段中添加选项时用到
      showCurrentOption: false, // 选项内容填写input显示
      currentColumnIndex: -1,// 正在编辑的选项内容
      columnTypes: [{name: "文本", value: 11},{name: "长文本", value: 12},{name: "数字", value: 21},{name: "小数", value: 22},{name: "日期", value: 31},{name: "日期+时间", value: 32},{name: "图片", value: 41},{name: "选项", value: 51},{name: "多选", value: 52}],
      showDictionary: false, // 编辑字典
    };
  },
  created() {
    util.getUserInfo().then(user => {
      this.merchantId = user.merchantId;
      // 查询数据
      this.queryList();
    })

    // 查询服务
    dictionaryApi.queryDynamicService().then(list => this.serviceList = list);
  },
  mounted() {
    this.$nextTick().then(() => {
      const el = document.querySelector('#dragTable table tbody')
      new Sortable(el, {
        sort: true,
        ghostClass: 'sortable-ghost',
        onEnd: (e) => {
          let tableData = [...this.currentData.dynamicInfoJson];
          const targetRow = tableData.splice(e.oldIndex, 1)[0]
          tableData.splice(e.newIndex, 0, targetRow);
          // 重新渲染
          this.currentData.dynamicInfoJson = [];
          this.$nextTick().then(() => {
            this.currentData.dynamicInfoJson = tableData
            // 保存数据
            this.saveNotRefresh();
          });
          console.log(tableData);
        },
      })
    })
  },
  methods: {
    removeOption(idx) {
      this.currentColumn.labelOptions.splice(idx, 1);
    },
    moreOption(command, data) {
      switch ( command) {
        case "addNewCategory":
          this.toEditData({id: '', parentId: data.id});
          break;
        case "editCategory":
          this.toEditData(data);
          break;
        case "deleteCategory":
          ElMessageBox.confirm("是否确认删除这个分类？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.toDeleteData(data.id, data)
          });
          break;
      }
    },
    // 选中某个字典
    selectData(data) {
      // 查询明细信息
      this.toShowDetail(data);
    },
    toShowDetail(data) {
      this.currentData = {
        ...data,
        dynamicInfoJson: JSON.parse(data.dynamicInfo) || [],
      };
    },
    queryList() {
      dictionaryApi.queryDynamicList({}, this.merchantId).then(list => {
        this.dictionaryList = list;
        this.treeList = [{children: list, dictName: "全部"}];
      })
    },
    // 新建
    toEditData(data) {
      if (data.id) {
        // 有数据
        this.selectData(data);
        this.showDictionary = true;
      } else if (data.parentId) {
        // 找到父节点
        this.currentData = {
          parentId: data.parentId,
          dynamicInfoJson: [],
          formType: data.formType,
        }
        this.showDictionary = true;
      } else {
        // 新建
        this.currentData = {
          ...data,
          dynamicInfoJson: [],
          formType: "",
        };
        this.showDictionary = true;
      }
    },
    // 删除字典
    toDeleteData(id, data) {
      // 如果有下级字典，不允许删除
      if (data.children && data.children.length > 0) {
        this.$message.error("请先删除下级字典");
        return;
      }
      dictionaryApi.deleteById({id}).then(() => this.queryList());
    },
    saveData() {
      let data = {
        ...this.currentData,
        type: this.dictionSetting.dictCode,
        dynamicInfo: JSON.stringify(this.currentData.dynamicInfoJson),
      }
      dictionaryApi.saveDynamic(data).then((data) => {
        this.toShowDetail(data);
        this.queryList();
        this.showDictionary = false;
        // 保存后置空
        this.currentData = {id: "-1"}
      });
    },
    // 添加一个新的字段
    editColumn(data, index) {
      if (data) {
        // 由于使用了arr作为属性，需要深拷贝
        this.currentColumn = this.$deepClone(data);
      } else {
        this.currentColumn = {
          labelOptions: [], // 选项
        };
      }
      this.currentColumnIndex = index; // 是新增
      this.showColumnSetting = true;
    },
    // 删除一个字段
    deleteColumn(index) {
      this.currentData.dynamicInfoJson = this.currentData.dynamicInfoJson.remove(index);
      this.saveNotRefresh();
    },
    saveNotRefresh() {
      let data = {
        ...this.currentData,
        type: this.dictionSetting.dictCode,
        dynamicInfo: JSON.stringify(this.currentData.dynamicInfoJson),
      }
      dictionaryApi.saveDynamic(data).then(() => {
        this.showColumnSetting = false;
        // 刷新table显示
        this.$refs.yqTable.showDataColumns();
      });
    },
    // 添加到列表
    addColumn2List() {
      if (!this.currentColumn.userCode) {
        this.$message.error("请输入字段编码");
        return;
      }
      if (!this.currentColumn.labelName) {
        this.$message.error("请输入字段名称");
        return;
      }
      // 如果是新增
      if (this.currentColumnIndex === -1) {
        // 是新增
        this.currentData.dynamicInfoJson.push(this.currentColumn);
      } else {
        this.currentData.dynamicInfoJson[this.currentColumnIndex] = this.currentColumn;
      }
      // 保存数据，不更新页面
      this.saveNotRefresh();
    },
    // 向自定义字段添加选项
    addLabelOption() {
      this.currentOption = "";
      this.showCurrentOption = true;
    },
    // 向自定义字段添加选项
    addOption2Label() {
      if (this.currentOption) {
        this.currentColumn.labelOptions.push(this.currentOption);
      }
      this.showCurrentOption = false;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tree";
.dynamic-content{
  padding-top: 10px;
  box-sizing: border-box;
}
.el-tag-option{
  margin-left: 10px;
  border: 1px solid var(--el-color-primary);
}
.el-tag-option:first-child{
  margin-left: 0;
}

.label-options{
  display: inline-block;
  width: 50%;
  box-sizing: border-box;
  margin-bottom: 10px;
  .option{
    //border: 1px solid var(--el-color-primary-light-8);
    //background: var(--el-color-primary-light-9);
    //border-radius: 4px;
    //font-size: 12px;
    //color: var(--el-color-primary);
    position: relative;
    .yq-icon{
      position: absolute;
      right: 0;
      top: 0;
      color: var(--el-color-danger);
    }
  }
}
.label-options:nth-child(2n){
  padding-left: 10px;
}
.label-options:nth-child(2n + 1){
  padding-right: 10px;
}
.label-options.level-1{
  width: 100%;
  border: 1px solid var(--el-color-primary);
  color: var(--el-color-primary);
  text-align: center;
  height: 35px;
  line-height: 35px;
  border-radius: 4px;
}
.node-name{
  .form-tag{
    border: 1px solid var(--el-color-primary-light-8);
    background-color: var(--el-color-primary-light-9);
    padding: 0 5px;
    border-radius: 4px;
    color: var(--el-color-primary);
  }
}
.form-item-desc{
  font-size: 10px;
  position: absolute;
  left: 10px;
  bottom: -23px;
  color: #999;
}
</style>